import { useSelector } from "react-redux";
import { getSearchResultsFlightOffers } from "../store/searchResults/selectors.js";
const useSearchResultOffer = (offerToken) => {
    const searchResultsFlightOffers = useSelector(getSearchResultsFlightOffers);
    return searchResultsFlightOffers?.find((offer) => offer.token === offerToken);
};
const usePrefetchedBrandedFaresOffer = (offerToken) => {
    const searchResultsFlightOffers = useSelector(getSearchResultsFlightOffers);
    return searchResultsFlightOffers?.find((offer) => offer?.brandedFareOffers?.find((brandedFareOffer) => brandedFareOffer.token === offerToken));
};
export { useSearchResultOffer, usePrefetchedBrandedFaresOffer };
